<template>
  <CustomMaskedInput
    :appimage="appimage"
    class="input date-chip"
    :clearable="clearable"
    :disabled="disabled"
    :error="error"
    :label="label"
    :mask="$i18n.locale === 'en' ? '11/11/1111' : '11.11.1111' "
    :message="error_message"
    :model.sync="model_text"
    :placeholder="maskPlaceholder"
    placeholder_char=" "
    :prefix="!!prefix"
    :readonly="readonly"
    @click="ev => $emit('click', ev)"
    @input="dateRule">
    <template
      v-if="!!prefix"
      #prefix>
      <span class="grey--text"> {{ prefix }}</span>
    </template>
    <template
      v-if="appimage || clearable"
      #appimage>
      <sIcon
        v-if="appimage"
        class="my-auto"
        size="14"
        type="calendar"/>
      <sButton
        v-if="clearable && model_text"
        data-qa="btn-clear"
        :disabled="disabled"
        icon="cross"
        small
        type="text"
        @click.stop="clear"/>
    </template>
  </CustomMaskedInput>
</template>
<script>
import CustomMaskedInput from 'components/common/inputs/CustomMaskedInput.vue'

import moment from 'moment'

export default {
  name: 'dateField',
  props: {
    rules: Array,
    model: [String, Number],
    prefix: String,
    appimage: Boolean,
    label: String,
    readonly: {
      type: Boolean,
      default: true
    },
    min_error: [Object, String, Boolean],
    min_date_for: String,
    clearable: Boolean,
    disabled: [ Boolean, String ],
    error: {
      type: Boolean
    }
  },
  data() {
    return {
      error_text: '',
      maskPlaceholder: '  .  .    '
    }
  },
  computed: {
    model_text: {
      get() {
        return this.model || ''
      },
      set(value) {
        this.$emit('update:model', value)
      }
    },
    error_message() {
      if ( this.error_text ) {
        return this.$t('Tenders.EnterCorectDate')
      } else if ( this.min_error ) {
        return this.min_error
      }
      return ''
    }
  },
  methods: {
    dateRule(text) {
      if (!text || text === this.maskPlaceholder) {
        this.$emit('changeText', null)
        return (this.error_text = false)
      }
      let rules = true
      if (this.rules && this.rules.length > 0) {
        rules = this.rules.every(rule => rule())
      }
      let corect = this.checkDate(text)
      if (corect) {
        this.$emit('changeText', text)
      }
      //text.match(/^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|(([1][26]|[2468][048]|[3579][26])00))))$/)
      this.error_text = !corect || !rules ? this.$t('Tenders.EnterCorectDate') : false
    },
    checkDate(dt) {
      if (dt == '') {
        return false
      }

      let pattern = this.$i18n.locale === 'en' ? /^(\d{2})(\/)(\d{2})(\/)(\d{4})$/ :  /^(\d{2})(.)(\d{2})(.)(\d{4})$/
      let dtArray = dt.match(pattern)

      if (dtArray == null) {
        return false
      }
      //Checks for mm/dd/yyyy format.
      let
        dtMonth = this.$i18n.locale === 'en' ? parseInt(dtArray[1]) : parseInt(dtArray[3]),
        dtDay = this.$i18n.locale === 'en' ? parseInt(dtArray[3]) : parseInt(dtArray[1]),
        dtYear = parseInt(dtArray[5])
      if (dtMonth < 1 || dtMonth > 12) {
        return false
      } else if (dtDay < 1 || dtDay > 31) {
        return false
      } else if ((dtMonth == 4 || dtMonth == 6 || dtMonth == 9 || dtMonth == 11) && dtDay == 31) {
        return false
      } else if (dtMonth == 2) {
        var isleap = (dtYear % 4 == 0 && (dtYear % 100 != 0 || dtYear % 400 == 0))
        if (dtDay > 29 || (dtDay == 29 && !isleap)) {
          return false
        }
      }
      return true
    },
    clear() {
      this.model_text = null
      this.$emit('changeText', null)

      this.$nextTick(() => {
        this.$emit('clear')
      })
    }
  },
  filters: {
    formatDate(value) {
      if (value && moment(value).isValid()) {
        return moment(value).format(this.$i18n.locale === 'en' ? 'MM/DD/YYYY' : 'DD.MM.YYYY')
      } else {
        return value
      }
    },
  },
  mounted() {
    this.maskPlaceholder = this.$i18n.locale === 'en' ? '  -  -    ' : '  .  .    '
  },
  components: {
    CustomMaskedInput
  }
}
</script>
<style lang="scss">
.date-chip .custom-masked-input{
  cursor: pointer;
}
</style>
